import React, { useState } from "react";
import {
    Card,
    CardMedia,
    CardContent,
    Typography,
    Button,
    Dialog,
    DialogContent,
    DialogActions,
    Grid,
    Container,
    Box,
} from "@mui/material";

const teamMembers = [
    {
        name: "Venkata Subba Reddy Atluri",
        role: "Founder and CEO",
        image: "/images/team2.jpeg",
        description: [
            "Venkata Subba Reddy Atluri has more than 25 years of IT experience in the space of Data Management & Data warehouse technologies. Worked to build analytical systems, Data Lakes, EDW & BI systems for different domains telecom, retail, financials & Manufacturing. And build large-scale data management systems from 4 to 20 Pita bytes",
            "Have a proven track record of improving data quality, mitigating data risks, achieving productivity and efficiency saves, reducing costs, and building a strong and efficient team. Also worked and demonstrated strong global stakeholder partnership, by working with teams across Asia, EMEA, and US, to drive and implement robust data solutions.",
            "In this journey worked for prestigious organizations like Tesco, PayPal, Etisalat, Uninor,  Orange Network, Dialog Telecom, and service-based companies Wipro, Tech Mahindra, Nuwara Systems and also worked e-governance for GOA state. In this career Played different roles as a Database Architect, ETL Architect, OLAP Architect, MDM Architect, Information Architect, E2E Architect, Senior Solution Architect, and Chief Technical Architect.",
        ],
    },
    {
        name: "Dr. BaskeraRao Shastri",
        role: "Director",
        image: "/images/team1.jpeg",
        description: [
            "Dr. BaskeraRao Shastri, a distinguished scholar, holds a doctorate from Multimedia University, Malaysia (MMU), an MBA from RMIT University, Australia, and a Master’s in Project Management from George Washington University, USA. An alumni of the National University of Malaysia (UKM) and an associate member of the Malaysian Institute of Management (MIM), he brings over 30 years of telecommunications expertise.",
            "In his extensive career at Telekom Malaysia(TM), Dr. BaskeraRao Shastri has excelled in developing and sustaining global markets for Telecommunications Products and Services, particularly in International Bandwidth, VSAT, Content Delivery platforms, and Data-Centres. Leading Digital Start-ups, he aims to enhance the value of offered services and products, ensuring substantial returns for consumers and corporate clients.",
            "Notable contributions include his role in the Project Management of the WiFi Project for Schools in Mauritius and the VSAT Project for Timor Leste. Actively engaged in Smart Meters and E-Sport Gaming projects abroad, Dr. BaskeraRao Shastri proficiency in gathering user requirements, finalizing specifications, and overseeing project activities is critical for success.",
            "Beyond his professional endeavors, Dr. BaskeraRao has held key positions, including Chairman of Sathya Sai Baba of Batu Caves Branch and Associate Member of JJ Consultants – Zambia Investment Committee. He is a Central Committee Member of the Islamic Green Development Bureau of the UK. As a part-time lecturer at Coventry University, he passionately delivers high-quality, result-oriented training for the MBA program.",
            "In January 2024, Dr. BaskeraRao Shastri assumed the role of Director, overseeing Malaysian operations at Vensyx Data Solutions Sdn Bhd, following his position as Chief Operating Officer at Innojc Technologies Sdn Bhd until 2023. His leadership continues to leave an enduring impact in the industries he serves.",
        ],
    },
];

function Teams() {
    const [open, setOpen] = useState(null);

    const handleOpen = (index) => setOpen(index);
    const handleClose = () => setOpen(null);

    return (
        <Container maxWidth="lg" sx={{ py: 2, textAlign: "center" }}>
            <Typography
                variant="h3"
                color="#030366"
                gutterBottom
                sx={{
                    fontWeight: "bold",
                    mb: 5,
                    mt: 7,
                    fontSize: { xs: "2rem", md: "3rem" },
                }}
            >
                Team
            </Typography>

            <Grid container spacing={4} justifyContent="center">
                {teamMembers.map((member, index) => (
                    <Grid item xs={12} sm={6} md={4} key={index}>
                        <Card
                            sx={{
                                cursor: "pointer",
                                mx: "auto",
                                width: 300,
                                textAlign: "center",
                                borderRadius: 3,
                                boxShadow: 3,
                            }}
                            onClick={() => handleOpen(index)}
                        >
                            {/* Image container */}
                            <Box
                                sx={{
                                    width: "100%",
                                    height: 300,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    overflow: "hidden",
                                    backgroundColor: "#f5f5f5",
                                }}
                            >
                                <CardMedia
                                    component="img"
                                    image={member.image}
                                    alt={member.name}
                                    sx={{
                                        width: "auto",
                                        height: "100%",
                                        objectFit: "contain",
                                    }}
                                />
                            </Box>

                            <CardContent>
                                <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                                    {member.name}
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    {member.role}
                                </Typography>
                            </CardContent>
                        </Card>

                        {/* Dialog */}
                        <Dialog
                            open={open === index}
                            onClose={handleClose}
                            maxWidth="md"
                            fullWidth
                        >
                            <DialogContent dividers>
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: { xs: "column", md: "row" }, // responsive layout
                                        gap: 3,
                                    }}
                                >
                                    {/* Image Section */}
                                    <Box
                                        sx={{
                                            flex: { md: "0 0 40%" },
                                            width: { xs: "100%", md: "auto" },
                                        }}
                                    >
                                        <img
                                            src={member.image}
                                            alt={member.name}
                                            style={{
                                                width: "100%",
                                                borderRadius: "8px",
                                                objectFit: "cover",
                                            }}
                                        />
                                    </Box>

                                    {/* Text Section */}
                                    <Box
                                        sx={{
                                            flex: "1",
                                            display: "flex",
                                            flexDirection: "column",
                                            mt: { xs: 2, md: 0 },
                                        }}
                                    >
                                        <Typography
                                            variant="h4"
                                            sx={{
                                                mb: 1,
                                                fontWeight: "600",
                                                textAlign: { xs: "center", md: "left" },
                                            }}
                                        >
                                            {member.name}
                                        </Typography>

                                        <Typography
                                            variant="h6"
                                            sx={{
                                                mb: 2,
                                                fontWeight: "bold",
                                                color: "#030366",
                                                textAlign: { xs: "center", md: "left" },
                                            }}
                                        >
                                            {member.role}
                                        </Typography>

                                        {member.description.map((para, i) => (
                                            <Typography
                                                key={i}
                                                paragraph
                                                sx={{
                                                    fontFamily: "Raleway, sans-serif",
                                                    textAlign: "justify",
                                                    fontSize: { xs: "16px", md: "18px" },
                                                    lineHeight: 1.8,
                                                }}
                                            >
                                                {para}
                                            </Typography>
                                        ))}
                                    </Box>
                                </Box>
                            </DialogContent>

                            <DialogActions sx={{ justifyContent: "center" }}>
                                <Button onClick={handleClose} variant="contained" sx={{ bgcolor: "#030366" }}>
                                    Close
                                </Button>
                            </DialogActions>
                        </Dialog>
                    </Grid>
                ))}
            </Grid>
        </Container>
    );
}

export default Teams;






// import React, { useState } from "react";
// import {
//     Card,
//     CardMedia,
//     CardContent,
//     Typography,
//     Button,
//     Dialog,
//     DialogTitle,
//     DialogContent,
//     DialogActions,
//     Grid,
//     Container,
//     Box,
// } from "@mui/material";

// const teamMembers = [
//     {
//         name: "Venkata Subba Reddy Atluri",
//         role: "Founder and CEO",
//         image: "/images/team2.jpeg",
//         description: [
//             "Venkata Subba Reddy Atluri has more than 25 years of IT experience in the space of Data Management & Data warehouse technologies. Worked to build analytical systems, Data Lakes, EDW & BI systems for different domains telecom, retail, financials & Manufacturing. And build large-scale data management systems from 4 to 20 Pita bytes",
//             "Have a proven track record of improving data quality, mitigating data risks, achieving productivity and efficiency saves, reducing costs, and building a strong and efficient team. Also worked and demonstrated strong global stakeholder partnership, by working with teams across Asia, EMEA, and US, to drive and implement robust data solutions.",
//             "In this journey worked for prestigious organizations like Tesco, PayPal, Etisalat, Uninor,  Orange Network, Dialog Telecom, and service-based companies Wipro, Tech Mahindra, Nuwara Systems and also worked e-governance for GOA state. In this career Played different roles as a Database Architect, ETL Architect, OLAP Architect, MDM Architect, Information Architect, E2E Architect, Senior Solution Architect, and Chief Technical Architect.",
//         ],
//     },
//     {
//         name: "Dr. BaskeraRao Shastri",
//         role: "Director",
//         image: "/images/team1.jpeg",
//         description: [
//             "Dr. BaskeraRao Shastri, a distinguished scholar, holds a doctorate from Multimedia University, Malaysia (MMU), an MBA from RMIT University, Australia, and a Master’s in Project Management from George Washington University, USA. An alumni of the National University of Malaysia (UKM) and an associate member of the Malaysian Institute of Management (MIM), he brings over 30 years of telecommunications expertise.",
//             "In his extensive career at Telekom Malaysia(TM), Dr. BaskeraRao Shastri has excelled in developing and sustaining global markets for Telecommunications Products and Services, particularly in International Bandwidth, VSAT, Content Delivery platforms, and Data-Centres. Leading Digital Start-ups, he aims to enhance the value of offered services and products, ensuring substantial returns for consumers and corporate clients.",
//             "Notable contributions include his role in the Project Management of the WiFi Project for Schools in Mauritius and the VSAT Project for Timor Leste. Actively engaged in Smart Meters and E-Sport Gaming projects abroad, Dr. BaskeraRao Shastri proficiency in gathering user requirements, finalizing specifications, and overseeing project activities is critical for success.",
//             "Beyond his professional endeavors, Dr. BaskeraRao has held key positions, including Chairman of Sathya Sai Baba of Batu Caves Branch and Associate Member of JJ Consultants – Zambia Investment Committee. He is a Central Committee Member of the Islamic Green Development Bureau of the UK. As a part-time lecturer at Coventry University, he passionately delivers high-quality, result-oriented training for the MBA program.",
//             "In January 2024, Dr. BaskeraRao Shastri assumed the role of Director, overseeing Malaysian operations at Vensyx Data Solutions Sdn Bhd, following his position as Chief Operating Officer at Innojc Technologies Sdn Bhd until 2023. His leadership continues to leave an enduring impact in the industries he serves.",
//         ],
//     },
// ];

// function Teams() {
//     const [open, setOpen] = useState(null);

//     const handleOpen = (index) => setOpen(index);
//     const handleClose = () => setOpen(null);

//     return (
//         <Container maxWidth="lg" sx={{ py: 2, textAlign: "center" }}>
//             <Typography
//                 variant="h3"
//                 color="#030366"
//                 gutterBottom
//                 sx={{ fontWeight: "bold", mb: 5, mt: 7 }}
//             >
//                 Team
//             </Typography>

//             <Grid
//                 container
//                 spacing={4}
//                 justifyContent="center"
//                 alignItems="flex-start"
//             >
//                 {teamMembers.map((member, index) => (
//                     <Grid item xs={12} sm={6} md={4} key={index}>
//                         <Card
//                             sx={{
//                                 cursor: "pointer",
//                                 mx: "auto",
//                                 width: 300,
//                                 textAlign: "center",
//                             }}
//                             onClick={() => handleOpen(index)}
//                         >
//                             {/* Image container with fixed aspect ratio */}
//                             <Box
//                                 sx={{
//                                     width: "100%",
//                                     height: 300, // fixed height for uniformity
//                                     display: "flex",
//                                     alignItems: "center",
//                                     justifyContent: "center",
//                                     overflow: "hidden",
//                                     backgroundColor: "#f5f5f5", // optional background
//                                 }}
//                             >
//                                 <CardMedia
//                                     component="img"
//                                     image={member.image}
//                                     alt={member.name}
//                                     sx={{
//                                         width: "auto",
//                                         height: "100%", // full height inside container
//                                         objectFit: "contain", // ensures full image is visible
//                                     }}
//                                 />
//                             </Box>

//                             <CardContent>
//                                 <Typography variant="h6" sx={{ fontWeight: "bold" }}>
//                                     {member.name}
//                                 </Typography>
//                                 <Typography variant="body2" color="text.secondary">
//                                     {member.role}
//                                 </Typography>
//                             </CardContent>
//                         </Card>

//                         <Dialog
//                             open={open === index}
//                             onClose={handleClose}
//                             maxWidth="md"
//                             fullWidth
//                         >
//                             <DialogContent dividers>
//                                 <Box sx={{ display: "flex", gap: 2 }}>
//                                     {/* Left side: Image */}
//                                     <Box sx={{ flex: "0 0 40%" }}>
//                                         <img
//                                             src={member.image}
//                                             alt={member.name}
//                                             style={{ width: "100%", borderRadius: "8px" }}
//                                         />
//                                     </Box>

//                                     {/* Right side: Title and content */}
//                                     <Box sx={{ flex: "1", display: "flex", flexDirection: "column" }}>
//                                         <Typography variant="h4" sx={{ mb: 1, fontWeight: "600" }}>
//                                             {member.name}
//                                         </Typography>
//                                         <Typography variant="h6" sx={{ mb: 1, fontWeight: "bold" }}>
//                                             {member.role}
//                                         </Typography>
//                                         {member.description.map((para, i) => (
//                                             <Typography
//                                                 key={i}
//                                                 paragraph
//                                                 sx={{ fontFamily: "Raleway, sans-serif" }}
//                                             >
//                                                 {para}
//                                             </Typography>
//                                         ))}
//                                     </Box>
//                                 </Box>
//                             </DialogContent>

//                             <DialogActions>
//                                 <Button onClick={handleClose} color="primary">
//                                     Close
//                                 </Button>
//                             </DialogActions>
//                         </Dialog>

//                     </Grid>
//                 ))}
//             </Grid>
//         </Container>
//     );
// }

// export default Teams;
